import { useState } from "react";
import { buildInitialFormState, normalizeFormValuesByFields } from "../helpers";
import { IFieldDefinition, IFormState } from "../interfaces";
import { RecordFormModal } from "./RecordFromModal";

interface IEditRecordModalContentProps<TRecord extends object> {
  title: string;
  fields: IFieldDefinition<any>[];
  record: TRecord;
  onSaved: (record: TRecord, initialValues: IFormState, values: IFormState) => Promise<void> | void;
}

export const EditRecordModalContent = <TRecord extends object>(props: IEditRecordModalContentProps<TRecord>) => {
  const { title, fields, record, onSaved } = props;

  const [initialSnapshot] = useState<IFormState>(() => {
    return buildInitialFormState(fields, record as Record<string, unknown>);
  });

  return (
    <RecordFormModal
      title={`Edit ${title}`}
      fields={fields}
      initialFormState={initialSnapshot}
      onSaved={(values) => {
        const normalizedInitialValues = normalizeFormValuesByFields(initialSnapshot, fields);
        const normalizedValues = normalizeFormValuesByFields(values, fields);

        return onSaved(record, normalizedInitialValues, normalizedValues);
      }}
    />
  );
};
